/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ActiveTask = {
    description: `Represents a single Celery task that is currently active on a worker.`,
    properties: {
        id: {
            type: 'string',
            description: `Unique Celery ID of the task.`,
            isRequired: true,
        },
        name: {
            type: 'string',
            description: `Name of the Celery task.`,
            isRequired: true,
        },
        args: {
            type: 'array',
            contains: {
                properties: {
                },
            },
        },
        kwargs: {
            type: 'dictionary',
            contains: {
                properties: {
                },
            },
        },
        time_start: {
            type: 'any-of',
            description: `Time (POSIX timestamp) when the worker started the task.`,
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        worker_pid: {
            type: 'any-of',
            description: `Process ID of the worker handling this task.`,
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        delivery_info: {
            type: 'any-of',
            description: `Additional delivery information (exchange, routing key, etc.).`,
            contains: [{
                type: 'dictionary',
                contains: {
                    properties: {
                    },
                },
            }, {
                type: 'null',
            }],
        },
    },
} as const;
